import React from "react";
import { Typography, Box, Grid, Paper } from "@mui/material";

// Import images
import StarIcon from "../Images/Star.png";
import BulbIcon from "../Images/Bulb.png";
import StartupIcon from "../Images/Startup.png";
import CollegeIcon from "../Images/College.png";

export default function Steps() {
  return (
    <Box sx={{ bgcolor: "#f3f4f6", width: "98%" }}>
      {/* Main Content */}
      <Box
        sx={{
          // width: "100%",
          mx: "auto",
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 1, sm: 2, md: 3 },
        }}
      >
        <Grid container spacing={{ xs: 3, sm: 4, md: 6 }} alignItems="stretch">
          {/* Left Section - Steps */}
          <Grid
            item
            xs={12}
            md={6}
            alignItems={"center"}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Paper
              sx={{
                bgcolor: "#1f2937",
                borderRadius: { xs: "8px", md: "12px" },
                p: { xs: 2.5, sm: 3, md: 4 },
                // height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "300px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#9ca3af",
                  mb: 1,
                  fontSize: { xs: "0.8rem", sm: "0.875rem" },
                }}
              >
                In just 3 easy steps
              </Typography>
              <Box
                sx={{
                  width: "60px",
                  height: "4px",
                  bgcolor: "#f97316",
                  mb: { xs: 3, md: 4 },
                }}
              />

              {[
                {
                  step: "STEP 1",
                  text: "Fill the 'Partner Us Form Details'",
                },
                {
                  step: "STEP 2",
                  text: "Our Internal Team Will Process the Request",
                },
                {
                  step: "STEP 3",
                  text: "You officially onboard as a partner after due formalities",
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: { xs: 3, md: 4 },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 35, md: 40 },
                      height: { xs: 35, md: 40 },
                      borderRadius: "50%",
                      bgcolor: "#7e22ce",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      mr: 2,
                      fontSize: { xs: "0.9rem", md: "1rem" },
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: "bold",
                        color: "#c084fc",
                        fontSize: { xs: "0.7rem", sm: "0.75rem" },
                      }}
                    >
                      {item.step}
                    </Typography>
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        lineHeight: 1.4,
                      }}
                    >
                      {item.text}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Paper>
          </Grid>

          {/* Right Section - Partners */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                color: "#22c55e",
                mb: 3,
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              OUR EXISTING PARTNERS INCLUDE
            </Typography>

            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 3 }}
              justifyContent="center"
            >
              {[
                {
                  icon: StarIcon,
                  label: "Investors & Angel Investors",
                  description: "Connect with funding partners",
                  bg: "#E1DDF9",
                },
                {
                  icon: BulbIcon,
                  label: "Service Partners & Accelerators",
                  description: "Collaborate with innovation hubs",
                  bg: "#E1DDF9",
                },
                {
                  icon: StartupIcon,
                  label: "Startups & Corporates",
                  description: "Partner with growing businesses",
                  bg: "#E1DDF9",
                },
                {
                  icon: CollegeIcon,
                  label: "Colleges & Universities",
                  description: "Academic institution partnerships",
                  bg: "#E1DDF9",
                },
              ].map((partner, idx) => (
                <Grid item xs={6} sm={6} key={idx}>
                  <Paper
                    sx={{
                      bgcolor: partner.bg,
                      p: { xs: 1.5, sm: 2, md: 3 },
                      height: { xs: 140, sm: 160, md: 180 },
                      borderRadius: "12px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      transition: "transform 0.2s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: { xs: 80, sm: 100, md: 160 },
                        height: { xs: 80, sm: 100, md: 160 },
                        mb: { xs: 1, sm: 1.5 },
                      }}
                    >
                      <img
                        src={partner.icon}
                        alt={partner.label}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
